<template>
    <div class="row">
        <div class="col-6">
            <div class="card mt-4">
                <div class="card-header pb-0">
                <h6>Importación Masiva de Tareas</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex align-items-center">
                                <input type="file" ref="csvFile" class="form-control me-2" accept=".csv" @change="handleFileUpload" />

                            </div>
                        </div>

                        <div class="col-12 mt-2">
                            <div class="d-flex align-items-center">
                                <argon-button color="info" :disabled="!csvData.length || isUploading" @click="uploadTasks">
                                    Importar {{ csvData.length }} Tareas
                                </argon-button>
                            </div>
                        </div>
                    </div>


                <p class="text-xs mt-2 text-muted">
                    El CSV debe tener las columnas: <b>document, task_type_id, branch_id, description, due_date, priority</b>
                </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Papa from 'papaparse';
import axios from 'axios';
import Swal from 'sweetalert2';
import ArgonButton from '@/components/ArgonButton.vue';
export default {
    components:{ArgonButton},
    data() {
        return {
          csvData: [] ,
          isUploading: false
        };
    },
    methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        this.csvData = [];
        return;
      }

      Papa.parse(file, {
        header: true,
        // 'greedy' ignora filas que solo tienen espacios en blanco o comas vacías de Excel
        skipEmptyLines: 'greedy',
        transformHeader: header => header.trim(),
        complete: (results) => {
          this.csvData = results.data;
          console.log("Tareas detectadas por PapaParse:", this.csvData.length);
        },
        error: (error) => {
          console.error("Error al leer CSV:", error);
          Swal.fire('Error', 'No se pudo leer el archivo.', 'error');
        }
      });
    },

    async uploadTasks() {
      this.isUploading = true;
      // 1. Verificar que haya datos cargados
      if (!this.csvData || this.csvData.length === 0) {
        Swal.fire('Atención', 'No hay datos para importar o el archivo está vacío.', 'warning');
        this.isUploading = false;
        return;
      }

      // 2. Lógica de Validación
      for (let i = 0; i < this.csvData.length; i++) {
        let row = this.csvData[i];
        let rowNumber = i + 2; // +2 porque el index 0 es la fila 2 en Excel

        // A. Validar campos vacíos
        for (let key in row) {
          if (key === '' || key.startsWith('__')) continue;

          if (row[key] === null || row[key] === undefined || String(row[key]).trim() === '') {
            Swal.fire('Fila Incompleta', `La fila ${rowNumber} tiene el campo <b>"${key}"</b> vacío. Por favor, corrígelo antes de subir.`, 'error');
            this.isUploading = false;
            return; // Detiene el proceso
          }
        }

        // B. Validar símbolo de moneda en la columna "collect"
        if (row.collect !== undefined) {
          let monto = String(row.collect).trim();

          // Regex: busca cualquier cosa que NO sea un número (\d), un punto (.) o un signo menos (-)
          const hasCurrencySymbol = /[^\d.-]/.test(monto);

          if (hasCurrencySymbol) {
            Swal.fire('Formato Inválido', `En la fila ${rowNumber}, el monto <b>"${monto}"</b> contiene símbolos de moneda o letras. Solo se permiten números (ej. 21.04).`, 'error');
            this.isUploading = false;
            return; // Detiene el proceso
          }
        }
      }

      // 3. Confirmación de Importación
      const { isConfirmed } = await Swal.fire({
        title: '¿Confirmar Importación?',
        text: `Se validaron correctamente ${this.csvData.length} tareas listas para importar. ¿Deseas proceder?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#2dce89',
        cancelButtonColor: '#f5365c',
        confirmButtonText: 'Sí, importar',
        cancelButtonText: 'Cancelar'
      });

      if (!isConfirmed) return;

      // 4. Envío al Servidor
      try {
        const token = localStorage.getItem("accessToken");
        await axios.post(`${this.$store.state.apiURL}task/import`, {
          tasks: this.csvData,
          company_id: localStorage.getItem('companyId')
        }, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        Swal.fire('Éxito', 'Tareas importadas correctamente', 'success');

        // Limpiar datos
        this.csvData = [];
        if (this.$refs.csvFile) {
          this.$refs.csvFile.value = null;
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error || 'Error de conexión';
        Swal.fire('Error', 'Hubo un problema al importar: ' + errorMsg, 'error');
      }
      this.isUploading = false;
    }
  }
};
</script>